export default __webpack_public_path__ + "static/media/1.80460718.jpg";